var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B3B",
    d: "m18.134 13.767-5.334-9.6c-.716-1.292-1.708-2-2.8-2-1.091 0-2.083.708-2.8 2l-5.333 9.6c-.675 1.225-.75 2.4-.208 3.325.541.925 1.608 1.433 3.008 1.433h10.667c1.4 0 2.466-.508 3.008-1.433.542-.925.467-2.109-.208-3.325ZM9.375 8A.63.63 0 0 1 10 7.375a.63.63 0 0 1 .625.625v4.167a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V8Zm1.217 7.258-.125.1a.634.634 0 0 1-.15.075.502.502 0 0 1-.158.05c-.05.009-.109.017-.159.017s-.108-.008-.166-.017a.529.529 0 0 1-.15-.05.634.634 0 0 1-.15-.075l-.125-.1a.876.876 0 0 1-.242-.591c0-.217.092-.434.242-.592l.125-.1c.05-.033.1-.058.15-.075.05-.025.1-.042.15-.05a.713.713 0 0 1 .325 0 .502.502 0 0 1 .158.05c.05.017.1.042.15.075l.125.1c.15.158.242.375.242.592a.876.876 0 0 1-.242.591Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDanger);
export default __webpack_public_path__ + "static/media/alert-danger.c2a011667bf74efbbdd93cb3977c1dda.svg";
export { ForwardRef as ReactComponent };